import { memo, type ReactNode } from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider, type Theme } from '@mui/material/styles';

interface Props {
    children: ReactNode;
    embed?: boolean;
    theme: Theme;
}

function ThemeProvider({ children, embed, theme }: Props) {
    return embed ? (
        <MuiThemeProvider defaultMode="light" theme={theme} noSsr storageManager={null}>
            {children}
        </MuiThemeProvider>
    ) : (
        <MuiThemeProvider defaultMode="light" theme={theme} noSsr storageManager={null}>
            <CssBaseline />
            {children}
        </MuiThemeProvider>
    );
}

export default memo(ThemeProvider);
